<!--  -->
<template>
  <div class="container">
    <div class="box">
      <img
        class="img-2"
        src="~@/assets/images/active/active20220929/20221028-active.png"
        alt=""
      />

      <div class="btn-box">
        <a
          href="https://www.wjx.top/vm/rp1P7k0.aspx"
          target="_blank"
          class="btn"
          >立即报名</a
        >
      </div>
    </div>

    <div class="v4">
      <img
        v-if="showDownLoad"
        src="~@/assets/images/ad/ad2/5.png"
        alt=""
        class="v4_1"
        @click="onDownload"
      />
    </div>
  </div>
</template>

<script>
import { h5 } from "@/utils/env";
import { getWXEvn, isBangBangApp, isWeixin } from "@/utils";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      showDownLoad: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (isWeixin()) {
      getWXEvn({
        //如果是小程序
        isMiniApp: () => {
          this.showDownLoad = false;
        },
        //如果是公众号网页
        isWeixinNotMiniApp: () => {},
      });
    } else if (isBangBangApp()) {
      this.showDownLoad = false;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  //方法集合
  methods: {
    onDownload() {
      location.href = `${h5}app/install.html?source=ENGINEER`;
    },
  },
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.box {
  position: relative;
  box-sizing: border-box;
  width: 7.5rem;
  margin: 0 auto;

  .img-2 {
    display: block;
    width: 100%;
  }
}

.flex {
  display: flex;
  align-items: center;
}

.flex-between {
  justify-content: space-between;
}

.btn-box {
  box-sizing: border-box;
  position: absolute;
  bottom: 0.82rem;
  width: 100%;
  z-index: 10;

  .btn {
    display: block;
    width: 6.54rem;
    height: 0.9rem;
    background: #ffd413;
    box-shadow: 0rem 0rem 0.3rem 0rem #fc8150;
    border-radius: 0.45rem;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    font-size: 0.4rem;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    font-weight: 500;
    color: #fb4529;
    line-height: 0.9rem;
    letter-spacing: 1px;
  }
}
.v4 {
  position: absolute;
  top: 2rem;
  width: 1.01rem;
  right: 0;
  overflow: hidden;

  .v4_1,
  .share_bt {
    position: relative;
    width: 1.5rem;
    // right: -0.49rem;
  }
  .share_bt {
    margin-top: -0.55rem;
  }
}
</style>